export default "__VITE_ASSET__7b4d7ac7__"